/**
 * Styled Components - Created by david on 26/02/18.
 */
import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  background-color: #fff;
  height: 100vh;
`

export const Text = styled.div`
  color: #fff;
`

export const StyledTitle = styled.div`
  background-color: #fff;
  padding: 16px 0;
  box-sizing: border-box;
  color: black;
  min-height: 64px;
  font-size: 24px;
  text-align: left;
  flex: 1;
  margin-left: 15px;
`

export const Modes = styled.div`
  display: flex;
  position: absolute;
  top: 10px;
  left: 410px;
`



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/screens/DesignerTool/DesignCenterCustomize/styledComponents.tsx